// modules/LotHeading.js
import React      from 'react';
import Clr        from './Clr';

class LotHeading extends React.Component {
	render() {
			return (
				<div className="lfss-resultrow">
					<div className="lfss-result-heading-lot">Lot</div>
					<div className="lfss-result-heading">Stage</div>
					<div className="lfss-result-heading">Price</div>
					<div className="lfss-result-heading">Land Size</div>
					<div className="lfss-result-heading">Frontage</div>
					<div className="lfss-result-heading">Packages:</div>
					<Clr/>
				</div>
			);
	}
}

export default LotHeading;


/** WEBPACK FOOTER **
 ** ./src/modules/common/LotHeading.js
 **/